import { Component, OnDestroy, inject } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { EmployeeFormComponent } from '../form/employee-form.component';
import { Subscription } from 'rxjs';
import { OffcanvasHeaderBtnComponent } from '../../../../../shared/components/offcanvas/offcanvas-header-btn/offcanvas-header-btn.component';
import { OffcanvasBaseComponent } from '../../../../../shared/components/offcanvas/offcanvas-base/offcanvas-base.component';
import { HttpParams } from '@angular/common/http';

@Component({
  selector: 'app-edit-employee-details',
  imports: [EmployeeFormComponent, OffcanvasHeaderBtnComponent, OffcanvasBaseComponent, EmployeeFormComponent],
  templateUrl: './edit-employee-details.component.html',
})
export class EditEmployeeDetailsComponent implements OnDestroy {
  readonly route = inject(ActivatedRoute);

  protected returnUrl: string = '/employees';
  params = new HttpParams();
  subscriptions: Subscription = new Subscription();
  employeeId?: string = undefined;

  constructor() {
    this.subscriptions.add(
      this.route.params.subscribe({
        next: (params: Params) => {
          this.employeeId = params['id'];
        },
      }),
    );
  }
  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
